export enum TooltipType {
    Error = 'error',
    Warn = 'warn',
    Controls = 'controls',
    Info = 'info',
}
